import { API, graphqlOperation } from "aws-amplify";
import { getDeviceWithWorstSubstanceQuery } from "../../graphql/queries";
import { notificationFail } from "../slices/notificationSlice";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { setDeviceWithWorstSubstanceData } from "../slices/dashboardSlice";
import { setNewDashboardLoader } from "../slices/authSlice";
import {
  qaApi,
  prodApi,
  devApi,
  qaApidevApiMeasurementService,
  prodApiMeasurementService,
  devApiMeasurementService,
} from "../../aws-export";
import { ChangeServiceRequest } from "./commonThunk";
import GrafanaClient from "../../config/grafanaClient";
import DashboardDummyData from './dashboard_dummydata.json'
export const getDeviceWithWorstSubstanceData = createAsyncThunk(
  "getDeviceWithWorstSubstanceData",
  async (_request: any, { dispatch }) => {
    const loginwithtype = localStorage.getItem("loginwith") || "";
    
    try {
      dispatch(
        ChangeServiceRequest({
          request:
            loginwithtype === "qa"
              ? qaApidevApiMeasurementService
              : loginwithtype === "prod"
              ? prodApiMeasurementService
              : devApiMeasurementService,
        })
      );
      console.log("COMECOMECOMECOME", _request);      
      if(_request.tenantCode !== process.env.REACT_APP_TENANT_CODE){
          const worstSubstanceData: any = (await API.graphql(
            graphqlOperation(getDeviceWithWorstSubstanceQuery, {
              params: _request.request,
            })
          )) as { data: any; errors: any[] };
          if (worstSubstanceData?.data?.getDevicesWithWorstSubstances?.devices) {
            dispatch(
              setDeviceWithWorstSubstanceData(
                worstSubstanceData?.data?.getDevicesWithWorstSubstances?.devices || []
              )
            );
          } else {
            dispatch(setDeviceWithWorstSubstanceData([]));
          }
          dispatch(
            ChangeServiceRequest({
              request:
                loginwithtype === "qa"
                  ? qaApi
                  : loginwithtype === "prod"
                  ? prodApi
                  : devApi,
            })
          );
          return (
            worstSubstanceData?.data?.getDevicesWithWorstSubstances?.devices || []
          );
      }else{
        dispatch(setDeviceWithWorstSubstanceData([]));
        dispatch(setDeviceWithWorstSubstanceData(DashboardDummyData.getDevicesWithWorstSubstances.devices || []));
        return DashboardDummyData.getDevicesWithWorstSubstances.devices || []
      }

    } catch {
      dispatch(
        ChangeServiceRequest({
          request:
            loginwithtype === "qa"
              ? qaApi
              : loginwithtype === "prod"
              ? prodApi
              : devApi,
        })
      );
      dispatch(notificationFail("Something went wrong"));
    } finally {
      // Ensure the dashboard loader is set to false after the operation completes
      dispatch(setNewDashboardLoader(false));
    }
  }
);

export const exportSubstanceReport = createAsyncThunk(
  "exportSubstanceReport",
  async (_request: any, { dispatch }) => {
    try {
      const exportResultData: any = await GrafanaClient().post(
        "/export-report/export-substance-report",
        _request
      );
      return exportResultData?.data;
    } catch {
      dispatch(notificationFail("Something went wrong"));
    }
  }
);

export const exportThresholdReport = createAsyncThunk(
  "exportThresholdReport",
  async (_request: any, { dispatch }) => {
    try {
      const exportResultData: any = await GrafanaClient().post(
        "/export-report/export-threshold-report",
        _request
      );
      return exportResultData?.data;
    } catch {
      dispatch(notificationFail("Something went wrong"));
    }
  }
);
